import { render, staticRenderFns } from "./ChildrenDirections.vue?vue&type=template&id=44e144cf"
import script from "./ChildrenDirections.vue?vue&type=script&lang=js"
export * from "./ChildrenDirections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports